import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const Wrapper = styled(motion.div)<{ $marketplaceEnabled?: boolean }>`
    display: flex;
    align-items: center;
    gap: 5px;

    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%);

    ${({ $marketplaceEnabled }) =>
        !$marketplaceEnabled &&
        css`
            bottom: unset;
            top: 6px;
            right: 6px;
            left: unset;
            gap: 0;
            transform: none;
        `}
`;

export const ListButton = styled.button<{ $isCancel?: boolean }>`
    ${styledReset.button}

    height: 30px;
    padding: 0px;
    width: 100px;

    color: #fff;
    font-size: 12px;
    font-weight: 700;
    line-height: 20px;
    letter-spacing: -0.2px;
    white-space: nowrap;

    display: flex;
    justify-content: center;
    align-items: center;

    border-radius: 6px;
    background: #523df1;

    transition: box-shadow 200ms ease;
    pointer-events: all;
    user-select: none;

    &:hover {
        box-shadow:
            0 0 68px 0 rgba(255, 255, 255, 0.1) inset,
            0 0 0 1px rgba(255, 255, 255, 0.1) inset,
            0px 0px 30px 0px rgba(82, 61, 241, 0.6);
    }

    ${({ $isCancel }) =>
        $isCancel &&
        css`
            background: #f82222;
        `}
`;
